import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {CoreModule} from '@core/core.module';

import {SharedModule} from '@shared/shared.module';
import {CdkTableModule} from '@angular/cdk/table';
import {FormsModule} from '@angular/forms';
import {CommandService} from '@core/services/command.service';

import { FuseSharedModule } from '@barebone-fuse/@fuse/shared.module';
import { FuseSearchBarModule } from '@barebone-fuse/@fuse/components';
import {auditTrackerRoutes} from '@features/audit-tracker/audit-tracker.routes';
import {AuditTrackerDynamicComponentHelper} from '@features/audit-tracker/audit-tracker-dynamic-component-helper';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {AuditTrackerHandler} from '@features/audit-tracker/services/handlers/audit-tracker.handler';
import {PlatformCommand} from '@shared/commands/command-base';
import { AddAuditRecordDialogComponent } from './components/add-audit-record-dialog/add-audit-record-dialog.component';
import {AuditTrackerDetailsHandler} from '@features/audit-tracker/services/handlers/audit-tracker-details.handler';
import { StartWorkflowDialogComponent } from './components/start-workflow-dialog/start-workflow-dialog.component';
import { AuditCaseArchiveDialogComponent } from './components/audit-case-archive-dialog/audit-case-archive-dialog.component';
import { ReviewWorkflowDialogComponent } from './components/review-workflow-dialog/review-workflow-dialog.component';
import {AddAuditTrackerCaseCommandHandler} from '@features/audit-tracker/services/command-handlers/add-audit-tracker-case-command-handler';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {StartWorkFlowCommandHandler} from '@features/audit-tracker/services/command-handlers/start-work-flow-command-handler';
import {CloseCaseCommandHandler} from '@features/audit-tracker/services/command-handlers/close-case-command-handler';
import {ArchiveCaseCommandHandler} from '@features/audit-tracker/services/command-handlers/archive-case-command-handler';
import {ReOpenCaseCommandHandler} from '@features/audit-tracker/services/command-handlers/re-open-case-command-handler';
import {AuditTrackerImportCasesHandler} from '@features/audit-tracker/services/command-handlers/audit-tracker-import-cases-handler';
// import {AuditStageRecordHandler} from '@features/audit-tracker/services/handlers/audit-stage-record.handler';
import { EntityCellViewerComponent } from './components/cell-editor/entity-cell-viewer/entity-cell-viewer.component';
import { AddAuditStageRecordDialogComponent } from './components/add-audit-stage-record-dialog/add-audit-stage-record-dialog.component';
import {AddAuditStageRecordCommandHandler} from '@features/audit-tracker/services/command-handlers/add-audit-stage-record-command-handler';
import { StateSelectorCellEditorComponent } from './components/cell-editor/state-selector-cell-editor/state-selector-cell-editor.component';
import { TaskAssignedToCellViewerComponent } from './components/cell-editor/task-assigned-to-cell-viewer/task-assigned-to-cell-viewer.component';
import {AddAuditStageDialogComponent} from '@features/audit-tracker/components/add-audit-stage-dialog/add-audit-stage-dialog.component';
import {AddAuditStageCommandHandler} from '@features/audit-tracker/services/command-handlers/add-audit-stage-command-handler';
import {DeleteAuditStageRecordCommandHandler} from '@features/audit-tracker/services/command-handlers/delete-audit-stage-record-command-handler';
import { AuditTrackerAnalyticsComponent } from './components/audit-tracker-analytics/audit-tracker-analytics.component';
import {RenameAuditStageCommandHandler} from '@features/audit-tracker/services/command-handlers/rename-audit-stage-command-handler';
import {DeleteCaseCommandHandler} from '@features/audit-tracker/services/command-handlers/delete-case-command-handler';
import {CancelWorkFlowCommandHandler} from '@features/audit-tracker/services/command-handlers/cancel-work-flow-command-handler';
import { ResponseDaysAvailableCellViewerComponent } from './components/cell-editor/response-days-available-cell-viewer/response-days-available-cell-viewer.component';
import { AuditTrackerMagicLinkComponent } from './components/audit-tracker-magic-link/audit-tracker-magic-link.component';
import {ContactsModule} from '@features/contacts/contacts.module';
import {
  CaseLockUnlockCommandHandler
} from "@features/audit-tracker/services/command-handlers/case-lock-unlock-command-handler";
import { Api } from '@shared/constants/common-field.constants';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(auditTrackerRoutes),
    //  TODO: Import effect and reducers
    // EffectsModule.forFeature([TaskManagerEffect]),
    // StoreModule.forFeature('task-manager', taskManagerReducer),
    CdkTableModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    FuseSharedModule,
    FuseSearchBarModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    FormsModule,
    MatTooltipModule,
    SharedModule,
    CoreModule,
    ContactsModule
  ],
  declarations: [
    AddAuditRecordDialogComponent,
    StartWorkflowDialogComponent,
    AuditCaseArchiveDialogComponent,
    ReviewWorkflowDialogComponent,
    EntityCellViewerComponent,
    AddAuditStageRecordDialogComponent,
    StateSelectorCellEditorComponent,
    TaskAssignedToCellViewerComponent,
    AddAuditStageDialogComponent,
    AuditTrackerAnalyticsComponent,
    ResponseDaysAvailableCellViewerComponent,
    AuditTrackerMagicLinkComponent
  ],
  exports: [
    StateSelectorCellEditorComponent
  ],
  providers: [

  ]})
export class AuditTrackerModule {
  constructor(
              private commandService: CommandService,
              private auditTrackerHandler: AuditTrackerHandler,
              private auditTrackerDetailsHandler: AuditTrackerDetailsHandler,
              private addAuditTrackerCaseCommandHandler: AddAuditTrackerCaseCommandHandler,
              private platformApiProvider: PlatformApiProvider,
              private startWorkFlowCommandHandler: StartWorkFlowCommandHandler,
              private closeCaseCommandHandler: CloseCaseCommandHandler,
              private archiveCaseCommandHandler: ArchiveCaseCommandHandler,
              private reOpenCaseCommandHandler: ReOpenCaseCommandHandler,
              // private auditStageRecordHandler: AuditStageRecordHandler,
              private addAuditStageRecordCommandHandler: AddAuditStageRecordCommandHandler,
              private addAuditStageCommandHandler: AddAuditStageCommandHandler,
              private deleteAuditStageRecordCommandHandler: DeleteAuditStageRecordCommandHandler,
              private renameAuditStageCommandHandler: RenameAuditStageCommandHandler,
              private deleteCaseCommandHandler: DeleteCaseCommandHandler,
              private cancelWorkFlowCommandHandler: CancelWorkFlowCommandHandler,
              private caseLockUnlockCommandHandler: CaseLockUnlockCommandHandler,
              private auditTrackerImportCasesHandler: AuditTrackerImportCasesHandler
  ) {
    AuditTrackerDynamicComponentHelper.init();

    // TODO:  register handlers
    AuditTrackerDynamicComponentHelper.register('AuditTrackerHandler', auditTrackerHandler);
    AuditTrackerDynamicComponentHelper.register('AuditTrackerDetailsHandler', auditTrackerDetailsHandler);
    AuditTrackerDynamicComponentHelper.register('AddAuditTrackerCaseCommandHandler', addAuditTrackerCaseCommandHandler);
    AuditTrackerDynamicComponentHelper.register('StartWorkFlowCommandHandler', startWorkFlowCommandHandler);
    AuditTrackerDynamicComponentHelper.register('CloseCaseCommandHandler', closeCaseCommandHandler);
    AuditTrackerDynamicComponentHelper.register('CaseLockUnlockCommandHandler', caseLockUnlockCommandHandler);
    AuditTrackerDynamicComponentHelper.register('ArchiveCaseCommandHandler', archiveCaseCommandHandler);
    AuditTrackerDynamicComponentHelper.register('AuditTrackerImportCasesHandler', auditTrackerImportCasesHandler);
    AuditTrackerDynamicComponentHelper.register('ReOpenCaseCommandHandler', reOpenCaseCommandHandler);
    AuditTrackerDynamicComponentHelper.register('DeleteCaseCommandHandler', deleteCaseCommandHandler);
    // AuditTrackerDynamicComponentHelper.register('AuditStageRecordHandler', auditStageRecordHandler);
    AuditTrackerDynamicComponentHelper.register('AddAuditStageRecordCommandHandler', addAuditStageRecordCommandHandler);
    AuditTrackerDynamicComponentHelper.register('AddAuditStageCommandHandler', addAuditStageCommandHandler);
    AuditTrackerDynamicComponentHelper.register('DeleteAuditStageRecordCommandHandler', deleteAuditStageRecordCommandHandler);
    AuditTrackerDynamicComponentHelper.register('RenameAuditStageCommandHandler', renameAuditStageCommandHandler);
    AuditTrackerDynamicComponentHelper.register('CancelWorkFlowCommandHandler', cancelWorkFlowCommandHandler);

    // TODO: perform command
    const command = new PlatformCommand('CreateAuditTrackerLinkCommand', 'AuditTrackerApi');
    command.projectId = '[PROJECT_ID]';
    this.commandService.registrPlatformLinkCommand('/audit-tracker/cases', command);

    const dashboardCommand = new PlatformCommand('OpenSolutionDefaultDashboardCommand', Api.IntelliCanvasApi);
    dashboardCommand.waitForResponse = true;
    dashboardCommand.projectId = '[PROJECT_ID]';
    dashboardCommand.fieldValues['Solution'] = 'Audit Tracker';
    dashboardCommand.fieldValues['DesignMode'] = false;
    dashboardCommand.fieldValues['IgnoreRedirectUrl'] = true;
    this.commandService.registrPlatformLinkCommand('/audit-tracker/dashboard', dashboardCommand);

    const auditTrackerAnalyticsPlatformCommand = new PlatformCommand('OpenAuditTrackerAnalyticReportCommand', "FileStoreApi");
    auditTrackerAnalyticsPlatformCommand.waitForResponse = false;
    auditTrackerAnalyticsPlatformCommand.projectId = '[PROJECT_ID]';
    auditTrackerAnalyticsPlatformCommand.fieldValues['ReportType'] = 'AuditTracker';
    auditTrackerAnalyticsPlatformCommand.fieldValues['BreadcrumbText'] = 'AuditTracker~Analytics';
    auditTrackerAnalyticsPlatformCommand.fieldValues['BreadcrumbLink'] = '/audit-tracker/cases~audit-tracker/analytics';
    this.commandService.registrPlatformLinkCommand('/audit-tracker/analytics', auditTrackerAnalyticsPlatformCommand);
    this.platformApiProvider.registerDefault('FileStoreApi', '/audit-tracker/analytics');
    this.platformApiProvider.registerDefault('AuditTrackerApi', '/audit-tracker');

  }
}
